// extracted by mini-css-extract-plugin
export default {"warnings":"WarningGridCell_warnings__3Taj-"};